module.exports = __webpack_public_path__ + "img/philosophy_doctor.5e544044.webp";